import React from 'react';
import { useOutlet } from "react-router-dom";
import AssessmentMangerHome from './AssessmentMangerHome';
import AssessmentManagerTopNav from './AssessmentManagerTopNav';
import GoHubTopNav from '../sharedComponents/GoHubTopNav';
// import AssessmentManagerLeftNav from './AssessmentManagerLeftNav';

export default () => {
  const outlet = useOutlet()

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      paddingTop: '39px', // room for the fixed hub top nav
      boxSizing: 'border-box',
      background: '#f5f5f5',
      overflow: 'hidden'
    }}>
      <GoHubTopNav appLogo={<AssessmentManagerTopNav />} />
      <div style={{
        flex: 1,
        display: 'flex',
        overflow: 'hidden'
      }}>
        {/* <AssessmentManagerLeftNav /> */}
        <div style={{
          flex: 1,
          display: 'flex',
          overflow: 'auto',
          overflowX: 'hidden'
        }}>
          {outlet || <AssessmentMangerHome />}
        </div>
      </div>
    </div>
  )
}